<script lang="ts">
    import VerticalFiltersBar from '$saga/views/Search/VerticalFiltersBar.svelte';

    export let openAccordions: boolean;
</script>

<VerticalFiltersBar {openAccordions} />
